<template>
  <div>
    <div>
      <show-condition-field
        @new-show-condition="addConditionField"
        @remove="removeConditionalField"
        v-for="(n, index) in conditionFieldCount"
        :key="index"
        module-id="1"
      >
      </show-condition-field>
    </div>
  </div>
</template>

<script>
export default {
  props: ['index'],

  data() {
    return {
      conditionFieldCount: 1,
      conditionGroups: [],
    };
  },

  methods: {
    addConditionField: function () {
      this.conditionFieldCount += 1;
    },
    removeConditionalField(index) {
      this.rows.splice(index, 1);
    },
  },

  // created() {
  //     this.$on('newShowCondition', () =>  this.addConditionField() );
  // }
};
</script>

<style>
.show-condition-group {
  border: 2px solid gray;
}
</style>
